import LogoLink from '@/components/Header/components/LogoLink';
import styles from './termSheetHeader.module.scss';
import { ArrowRight, Button } from '@baseline/ui';
import Link from 'next/link';
import { cva, VariantProps } from 'class-variance-authority';

const TermSheetHeaderVariants = cva(styles.termSheetHeader, {
  variants: {
    position: {
      static: styles.static,
      fixed: styles.fixed
    }
  },
  defaultVariants: {
    position: 'static'
  }
});

type TermSheetHeaderProps = VariantProps<typeof TermSheetHeaderVariants> & {
  showDemoButton?: boolean;
};

export default function TermSheetHeader({
  position = 'static',
  showDemoButton = true
}: TermSheetHeaderProps) {
  return (
    <nav className={TermSheetHeaderVariants({ position })}>
      <LogoLink />
      {showDemoButton && (
        <Link className={styles.demoLink} href="/contact-us">
          <span>Get Demo</span>
          <Button
            id="term-sheet-header-demo-button"
            size="iconSmall"
            colorScheme="neutral"
          >
            <ArrowRight />
          </Button>
        </Link>
      )}
    </nav>
  );
}
